// extracted by mini-css-extract-plugin
export default {"table":"InvitesTable-module__table__NGAng","button":"InvitesTable-module__button__nted2"};